module.exports = __webpack_public_path__ + "static/helicopter-landing-composite-f5242f10d5fb5f5054a70ab6fb8a8171.jpg";